<template>
  <BTable
    :headers="headers"
    :actions="actions"
    :list="list"
    :items-per-page-options="[25, 50, 100, 200]"
    hide-default-header
    class="BTableReportsRoadmapCommon"
  >
    <!--  -->

    <template #header>
      <thead>
        <tr>
          <th rowspan="2" class="BTableReportsRoadmapCommon__header-top">
            <span>Объект АТЕ</span>
          </th>
          <th colspan="3" class="BTableReportsRoadmapCommon__header-top">
            <span>Направления</span>
          </th>
          <th colspan="6" class="BTableReportsRoadmapCommon__header-top">
            <span>Меры</span>
          </th>
        </tr>
        <tr>
          <template v-for="(header, index) in headers">
            <th
              v-if="index"
              :key="header.value"
              class="BTableReportsRoadmapCommon__header"
            >
              <div class="BTableReportsRoadmapCommon__vertical-text-container">
                <span
                  class="BTableReportsRoadmapCommon__vertical-text"
                  v-html="header.text"
                />
              </div>
            </th>
          </template>
        </tr>
      </thead>
    </template>

    <template #item="{ item, headers: headersList }">
      <tr class="BTableReportsRoadmapCommon__row" :class="`is-type--${item.type}`">
        <template v-for="header in headersList">
          <template v-if="header.value === 'name'">
            <td :key="header.value" :class="header.class">
              <router-link
                v-if="item[header.value].to"
                :to="item[header.value].to"
                :class="`is-type--${item.type}`"
                class="BTableReportsRoadmapCommon__name"
                v-text="item[header.value].name"
              />
              <div
                v-else
                class="BTableReportsRoadmapCommon__text-all"
                v-text="item[header.value].name"
              />
            </td>
          </template>

          <template v-else>
            <td
              :key="header.value"
              :style="header.style"
              :class="header.class"
              class="BTableReportsRoadmapCommon__number"
              v-text="item[header.value]"
            />
          </template>
        </template>
      </tr>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import { TABLE_HEADERS } from './table-headers'
import BTable from '@/components/common/BTable.vue'


export default {
  name: 'LKReportsRoadmapBasicStatisticsTable',
  components: {
    BTable,
  },
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
$border-color: rgba(0, 0, 0, 0.12);

@mixin row-color ($color, $color-hover: $color) {
  background-color: rgba($color, 0.1) !important;

  &:hover {
    background-color: rgba($color-hover, 0.3) !important;
  }
}

.BTableReportsRoadmapCommon {
  th {
    color: $color-black !important;
    text-align: left;
    word-break: break-word;
    border-bottom: thin solid $border-color;
    border-left: thin solid $border-color;
  }

  tr:last-child td {
    border-bottom: thin solid $border-color;
  }

  // stylelint-disable-next-line no-descending-specificity, selector-list-comma-newline-after
  th, td {
    height: auto !important;
    padding: 8px !important;
    font-size: 12px !important;
    border-left: thin solid $border-color;

    // stylelint-disable-next-line no-descending-specificity
    &:last-child {
      border-right: thin solid $border-color;
    }
  }

  &__header-top {
    text-align: center !important;
    border-top: thin solid $border-color;
  }

  & &__header {
    // width: 60px;
    min-width: 60px;
    // max-width: 140px;
  }

  &__vertical-text {
    $width: 104px;

    word-break: normal;

    @media screen and (max-width: 1440px) {
      position: absolute;
      display: block;
      width: $width;
      padding: 8px 0;
      line-height: 1.2;
      transform: rotate(270deg);

      &-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: $width;
      }
    }
  }

  &__text-all {
    font-size: 16px;
    font-weight: 700;
  }

  &__row {
    @include row-color($color-white);

    &.is-type {
      &--region {
        @include row-color($webflow-color-blue);
      }

      &--municipality {
        @include row-color($webflow-color-green);
      }

      &--school {
        @include row-color($color-white, $webflow-color-grey);
      }
    }
  }

  &__name {
    display: inline-block;
    color: inherit;
    text-decoration-line: none;

    &:hover {
      text-decoration-line: underline;
    }

    &.is-type {
      &--municipality {
        margin-left: 20px;
      }

      &--school {
        margin-left: 40px;
      }
    }
  }

  &__number {
    font-weight: 700;
    text-align: center;
    word-break: keep-all !important;
  }
}
</style>
